/* eslint-disable max-len */
import React from 'react';

const ManageMediaIcon = props => (
  <svg width={19} height={19} viewBox="0 0 19 19" {...props}>
    <path d="M6.707 15H4a1 1 0 0 1-1-1v-2.8c0-.11.09-.2.2-.2h.6c.11 0 .2.09.2.2V14h2.707l-.773-.773a.2.2 0 0 1 0-.283l.425-.424a.2.2 0 0 1 .282 0L8.48 14.36a.2.2 0 0 1 0 .282L6.64 16.48a.2.2 0 0 1-.282 0l-.425-.424a.2.2 0 0 1 0-.283L6.707 15zm5.586-11H15a1 1 0 0 1 1 1v2.8a.2.2 0 0 1-.2.2h-.6a.2.2 0 0 1-.2-.2V5h-2.707l.773.773a.2.2 0 0 1 0 .283l-.425.424a.2.2 0 0 1-.282 0L10.52 4.64a.2.2 0 0 1 0-.282L12.36 2.52a.2.2 0 0 1 .282 0l.425.424a.2.2 0 0 1 0 .283L12.293 4zM11 10h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1zm0 1v5h5v-5h-5zM3 2h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm0 1v5h5V3H3z" />
  </svg>
);

export default ManageMediaIcon;
